module.exports = __webpack_public_path__ + "img/asus-vivobook-x541na.105afdc2.jpg";